var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["macros/navigation-items.j2"] = require( "macros/navigation-items.j2" );
dependencies["facets/category-facets-navitem-nested.j2"] = require( "facets/category-facets-navitem-nested.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/category-facet-macro.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/macros/category-facet-macro.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("categoryUrl")) {
var t_4 = t_1.categoryUrl;
} else {
cb(new Error("cannot import 'categoryUrl'")); return;
}
context.setVariable("categoryUrl", t_4);
output += "\n";
env.getTemplate("macros/navigation-items.j2", false, "core/templates/macros/category-facet-macro.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("renderNavItem")) {
var t_8 = t_5.renderNavItem;
} else {
cb(new Error("cannot import 'renderNavItem'")); return;
}
context.setVariable("renderNavItem", t_8);
var macro_t_9 = runtime.makeMacro(
["breadcrumbs", "bcIndex", "bcLength", "selectedId"], 
["class", "nested"], 
function (l_breadcrumbs, l_bcIndex, l_bcLength, l_selectedId, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("breadcrumbs", l_breadcrumbs);
frame.set("bcIndex", l_bcIndex);
frame.set("bcLength", l_bcLength);
frame.set("selectedId", l_selectedId);
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
frame.set("nested", kwargs.hasOwnProperty("nested") ? kwargs["nested"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_10 = "";t_10 += "\n    ";
if(l_bcIndex < l_bcLength && l_breadcrumbs && runtime.memberLookup((l_breadcrumbs),l_bcIndex)) {
t_10 += "\n        ";
var t_11;
t_11 = runtime.memberLookup((l_breadcrumbs),l_bcIndex);
frame.set("crumb", t_11, true);
if(frame.topLevel) {
context.setVariable("crumb", t_11);
}
if(frame.topLevel) {
context.addExport("crumb", t_11);
}
t_10 += "\n        ";
var t_12;
t_12 = (runtime.memberLookup((runtime.memberLookup((l_breadcrumbs),0)),"parentSlug") == runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"marketingNavSlug"));
frame.set("crumbIsChildOfMarketingSlug", t_12, true);
if(frame.topLevel) {
context.setVariable("crumbIsChildOfMarketingSlug", t_12);
}
if(frame.topLevel) {
context.addExport("crumbIsChildOfMarketingSlug", t_12);
}
t_10 += "\n        ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "crumb")),"childSlugs") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "crumb")),"childSlugs")) > 0) || runtime.contextOrFrameLookup(context, frame, "crumbIsChildOfMarketingSlug")) {
t_10 += "\n            ";
if(runtime.contextOrFrameLookup(context, frame, "nested")) {
t_10 += "\n                ";
var t_13;
t_13 = "o-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__ul" + "" + "--nested";
frame.set("nestedListClass", t_13, true);
if(frame.topLevel) {
context.setVariable("nestedListClass", t_13);
}
if(frame.topLevel) {
context.addExport("nestedListClass", t_13);
}
t_10 += "\n                ";
var t_14;
t_14 = "o-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a" + "" + "--nested";
frame.set("nestedAnchorClass", t_14, true);
if(frame.topLevel) {
context.setVariable("nestedAnchorClass", t_14);
}
if(frame.topLevel) {
context.addExport("nestedAnchorClass", t_14);
}
t_10 += "\n            ";
;
}
else {
t_10 += "\n                ";
var t_15;
t_15 = "";
frame.set("nestedListClass", t_15, true);
if(frame.topLevel) {
context.setVariable("nestedListClass", t_15);
}
if(frame.topLevel) {
context.addExport("nestedListClass", t_15);
}
t_10 += "\n                ";
var t_16;
t_16 = "";
frame.set("nestedAnchorClass", t_16, true);
if(frame.topLevel) {
context.setVariable("nestedAnchorClass", t_16);
}
if(frame.topLevel) {
context.addExport("nestedAnchorClass", t_16);
}
t_10 += "\n            ";
;
}
t_10 += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "crumbIsChildOfMarketingSlug")) {
t_10 += "\n                ";
var t_17;
t_17 = runtime.memberLookup((l_breadcrumbs),0);
frame.set("crumb", t_17, true);
if(frame.topLevel) {
context.setVariable("crumb", t_17);
}
if(frame.topLevel) {
context.addExport("crumb", t_17);
}
t_10 += "\n            ";
;
}
t_10 += "\n\n           ";
t_10 += "\n            <ul itemscope itemtype=\"http://www.schema.org/SiteNavigationElement\" class=\"";
t_10 += runtime.suppressValue("o-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__ul", env.opts.autoescape);
t_10 += " ";
t_10 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "nestedListClass"), env.opts.autoescape);
t_10 += " js-accordion\" role=\"menu\" data-qa-category-navitems>\n            ";
frame = frame.push();
var t_20 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "crumb")),"childSlugs");
if(t_20) {var t_19 = t_20.length;
for(var t_18=0; t_18 < t_20.length; t_18++) {
var t_21 = t_20[t_18];
frame.set("childSlug", t_21);
frame.set("loop.index", t_18 + 1);
frame.set("loop.index0", t_18);
frame.set("loop.revindex", t_19 - t_18);
frame.set("loop.revindex0", t_19 - t_18 - 1);
frame.set("loop.first", t_18 === 0);
frame.set("loop.last", t_18 === t_19 - 1);
frame.set("loop.length", t_19);
t_10 += "\n                ";
var t_22;
t_22 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_21);
frame.set("navItem", t_22, true);
if(frame.topLevel) {
context.setVariable("navItem", t_22);
}
if(frame.topLevel) {
context.addExport("navItem", t_22);
}
t_10 += "\n\n                ";
if(runtime.contextOrFrameLookup(context, frame, "navItem")) {
t_10 += "\n                    ";
var t_23;
t_23 = (runtime.contextOrFrameLookup(context, frame, "class") != "" && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"itemId") == l_selectedId?"o-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a" + "" + "--current":"");
frame.set("currentlyActive", t_23, true);
if(frame.topLevel) {
context.setVariable("currentlyActive", t_23);
}
if(frame.topLevel) {
context.addExport("currentlyActive", t_23);
}
t_10 += "\n\n                    ";
if(l_bcIndex == 1 && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"childSlugs") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"childSlugs")) > 0) {
t_10 += "\n                        ";
env.getTemplate("facets/category-facets-navitem-nested.j2", false, "core/templates/macros/category-facet-macro.j2", null, function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
t_24.render(context.getVariables(), frame, function(t_27,t_25) {
if(t_27) { cb(t_27); return; }
t_10 += t_25
t_10 += "\n                    ";
})});
}
else {
t_10 += "\n                        ";
t_10 += runtime.suppressValue((lineno = 46, colno = 73, runtime.callWrap(t_8, "renderNavItem", context, [runtime.contextOrFrameLookup(context, frame, "navItem"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_28 = runtime.makeMacro(
["navItemToRender", "url", "target"], 
[], 
function (l_navItemToRender, l_url, l_target, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("navItemToRender", l_navItemToRender);
frame.set("url", l_url);
frame.set("target", l_target);
var t_29 = "";t_29 += "\n                            ";
var t_30;
t_30 = "noopener noreferrer";
frame.set("rel", t_30, true);
if(frame.topLevel) {
context.setVariable("rel", t_30);
}
if(frame.topLevel) {
context.addExport("rel", t_30);
}
t_29 += "\n\n                            <li itemprop=\"name\" class=\"";
t_29 += runtime.suppressValue("o-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__li", env.opts.autoescape);
t_29 += "\" role=\"menuitem\">\n                                <meta itemprop=\"url\" content=\"";
t_29 += runtime.suppressValue(env.getFilter("sanitize_url").call(context, (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"urls")),"canonical") + "" + l_url)), env.opts.autoescape);
t_29 += "\" />\n\n                                <a ";
if(l_target) {
t_29 += "target=\"";
t_29 += runtime.suppressValue(l_target, env.opts.autoescape);
t_29 += "\" ";
if(l_target == "_blank") {
t_29 += " rel=\"";
t_29 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "rel"), env.opts.autoescape);
t_29 += "\" ";
;
}
;
}
t_29 += " data-bc-index=";
t_29 += runtime.suppressValue(l_bcIndex, env.opts.autoescape);
t_29 += " href=\"";
t_29 += runtime.suppressValue(l_url, env.opts.autoescape);
t_29 += "\" class=\"";
t_29 += runtime.suppressValue("o-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a", env.opts.autoescape);
t_29 += " ";
t_29 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "nestedAnchorClass"), env.opts.autoescape);
t_29 += " ";
t_29 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "currentlyActive"), env.opts.autoescape);
t_29 += " ";
t_29 += runtime.suppressValue("js-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a", env.opts.autoescape);
t_29 += "\" role=\"menuitem\" data-qa-category-navitem=\"";
t_29 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"slug"), env.opts.autoescape);
t_29 += "\" ";
t_29 += runtime.suppressValue((lineno = 52, colno = 303, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 52, colno = 309, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"browse by",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"gaLabel")])), env.opts.autoescape);
t_29 += ">";
t_29 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"displayName"), env.opts.autoescape);
t_29 += "</a>\n\n                                ";
t_29 += "\n                                ";
if(l_bcIndex + 1 < l_bcLength && runtime.memberLookup((l_breadcrumbs),l_bcIndex + 1) && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"itemId") == runtime.memberLookup((runtime.memberLookup((l_breadcrumbs),l_bcIndex + 1)),"itemId")) {
t_29 += "\n                                    ";
t_29 += runtime.suppressValue((lineno = 58, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "buildExplodedBreadcrumbNav"), "buildExplodedBreadcrumbNav", context, [l_breadcrumbs,l_bcIndex + 1,l_bcLength,l_selectedId,runtime.contextOrFrameLookup(context, frame, "class"),runtime.contextOrFrameLookup(context, frame, "True")])), env.opts.autoescape);
t_29 += "\n                                ";
;
}
t_29 += "\n                            </li>\n                        ";
;
frame = frame.pop();
return new runtime.SafeString(t_29);
});
return macro_t_28;})()})])), env.opts.autoescape);
t_10 += "\n                    ";
;
}
t_10 += "\n                ";
;
}
t_10 += "\n            ";
;
}
}
frame = frame.pop();
t_10 += "\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_small") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_small") && l_bcIndex >= 1) {
t_10 += "\n                ";
var t_31;
t_31 = runtime.memberLookup((l_breadcrumbs),1);
frame.set("subCategory", t_31, true);
if(frame.topLevel) {
context.setVariable("subCategory", t_31);
}
if(frame.topLevel) {
context.addExport("subCategory", t_31);
}
t_10 += "\n                ";
var t_32;
t_32 = (runtime.inOperator(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "subCategory")),"slug"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "crumb")),"childSlugs"))?runtime.contextOrFrameLookup(context, frame, "False"):runtime.contextOrFrameLookup(context, frame, "True"));
frame.set("uniqueNavItem", t_32, true);
if(frame.topLevel) {
context.setVariable("uniqueNavItem", t_32);
}
if(frame.topLevel) {
context.addExport("uniqueNavItem", t_32);
}
t_10 += "\n\n                ";
if(runtime.contextOrFrameLookup(context, frame, "class") != "" && runtime.contextOrFrameLookup(context, frame, "subCategory") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "subCategory")),"itemId") == l_selectedId) {
t_10 += "\n                    ";
var t_33;
t_33 = "o-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a" + "" + "--current";
frame.set("currentlyActive", t_33, true);
if(frame.topLevel) {
context.setVariable("currentlyActive", t_33);
}
if(frame.topLevel) {
context.addExport("currentlyActive", t_33);
}
t_10 += "\n                ";
;
}
else {
t_10 += "\n                    ";
var t_34;
t_34 = "";
frame.set("currentlyActive", t_34, true);
if(frame.topLevel) {
context.setVariable("currentlyActive", t_34);
}
if(frame.topLevel) {
context.addExport("currentlyActive", t_34);
}
t_10 += "\n                ";
;
}
t_10 += "\n                ";
if(runtime.contextOrFrameLookup(context, frame, "subCategory") && runtime.contextOrFrameLookup(context, frame, "uniqueNavItem")) {
t_10 += "\n                    <li itemprop=\"name\" class=\"";
t_10 += runtime.suppressValue("o-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__li", env.opts.autoescape);
t_10 += "\" role=\"menuitem\">\n                        <a data-bc-index=";
t_10 += runtime.suppressValue(l_bcIndex, env.opts.autoescape);
t_10 += " href=\"";
t_10 += runtime.suppressValue((lineno = 76, colno = 67, runtime.callWrap(t_4, "categoryUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "subCategory")),"slug"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
t_10 += "\" class=\"";
t_10 += runtime.suppressValue("o-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a", env.opts.autoescape);
t_10 += " ";
t_10 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "currentlyActive"), env.opts.autoescape);
t_10 += " ";
t_10 += runtime.suppressValue("js-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a", env.opts.autoescape);
t_10 += "\" role=\"menuitem\" data-qa-category-navitem=\"";
t_10 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "subCategory")),"slug"), env.opts.autoescape);
t_10 += "\" ";
t_10 += runtime.suppressValue((lineno = 76, colno = 235, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 76, colno = 241, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"browse by",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "subCategory")),"gaLabel")])), env.opts.autoescape);
t_10 += ">";
t_10 += runtime.suppressValue((lineno = 76, colno = 325, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_categories-see-all-label"])), env.opts.autoescape);
t_10 += " ";
t_10 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "subCategory")),"displayName"), env.opts.autoescape);
t_10 += "</a>\n                    </li>\n                ";
;
}
t_10 += "\n            ";
;
}
t_10 += "\n            </ul>\n        ";
;
}
t_10 += "\n    ";
;
}
t_10 += "\n";
;
frame = frame.pop();
return new runtime.SafeString(t_10);
});
context.addExport("buildExplodedBreadcrumbNav");
context.setVariable("buildExplodedBreadcrumbNav", macro_t_9);
var macro_t_35 = runtime.makeMacro(
["categorySlug", "core"], 
["class", "isSubnav"], 
function (l_categorySlug, l_core, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("categorySlug", l_categorySlug);
frame.set("core", l_core);
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
frame.set("isSubnav", kwargs.hasOwnProperty("isSubnav") ? kwargs["isSubnav"] : false);
var t_36 = "";if(runtime.memberLookup((runtime.memberLookup((l_core),"flatNavigation")),l_categorySlug)) {
var t_37;
t_37 = runtime.memberLookup((runtime.memberLookup((l_core),"flatNavigation")),l_categorySlug);
frame.set("currentNavigationItem", t_37, true);
if(frame.topLevel) {
context.setVariable("currentNavigationItem", t_37);
}
if(frame.topLevel) {
context.addExport("currentNavigationItem", t_37);
}
var t_38;
t_38 = runtime.memberLookup((runtime.memberLookup((l_core),"flatNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentNavigationItem")),"parentSlug"));
frame.set("currentNavigationItemParent", t_38, true);
if(frame.topLevel) {
context.setVariable("currentNavigationItemParent", t_38);
}
if(frame.topLevel) {
context.addExport("currentNavigationItemParent", t_38);
}
if(env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentNavigationItem")),"childSlugs")) > 0) {
if(runtime.contextOrFrameLookup(context, frame, "isSubnav")) {
t_36 += runtime.suppressValue((lineno = 103, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "buildOffscreenNav"), "buildOffscreenNav", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentNavigationItem")),"childSlugs"),l_categorySlug,runtime.contextOrFrameLookup(context, frame, "class")])), env.opts.autoescape);
;
}
else {
t_36 += runtime.suppressValue((lineno = 105, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "loopThroughChildSlugs"), "loopThroughChildSlugs", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentNavigationItem")),"childSlugs"),l_categorySlug,runtime.contextOrFrameLookup(context, frame, "class")])), env.opts.autoescape);
;
}
;
}
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_36);
});
context.addExport("getCategoryNavigation");
context.setVariable("getCategoryNavigation", macro_t_35);
var macro_t_39 = runtime.makeMacro(
["childSlugs", "categorySlug"], 
["class"], 
function (l_childSlugs, l_categorySlug, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("childSlugs", l_childSlugs);
frame.set("categorySlug", l_categorySlug);
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
var t_40 = "";t_40 += "\n    <ul class=\"";
t_40 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__ul", env.opts.autoescape);
t_40 += "\" data-qa-category-navitems>";
frame = frame.push();
var t_43 = l_childSlugs;
if(t_43) {var t_42 = t_43.length;
for(var t_41=0; t_41 < t_43.length; t_41++) {
var t_44 = t_43[t_41];
frame.set("slug", t_44);
frame.set("loop.index", t_41 + 1);
frame.set("loop.index0", t_41);
frame.set("loop.revindex", t_42 - t_41);
frame.set("loop.revindex0", t_42 - t_41 - 1);
frame.set("loop.first", t_41 === 0);
frame.set("loop.last", t_41 === t_42 - 1);
frame.set("loop.length", t_42);
var t_45;
t_45 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_44);
frame.set("navItem", t_45, true);
if(frame.topLevel) {
context.setVariable("navItem", t_45);
}
if(frame.topLevel) {
context.addExport("navItem", t_45);
}
if(runtime.contextOrFrameLookup(context, frame, "navItem")) {
var t_46;
t_46 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"slug");
frame.set("itemSlug", t_46, true);
if(frame.topLevel) {
context.setVariable("itemSlug", t_46);
}
if(frame.topLevel) {
context.addExport("itemSlug", t_46);
}
if(runtime.contextOrFrameLookup(context, frame, "class") != "" && runtime.contextOrFrameLookup(context, frame, "itemSlug") == l_categorySlug) {
var t_47;
t_47 = "c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a" + "--current";
frame.set("currentlyActive", t_47, true);
if(frame.topLevel) {
context.setVariable("currentlyActive", t_47);
}
if(frame.topLevel) {
context.addExport("currentlyActive", t_47);
}
;
}
else {
var t_48;
t_48 = "";
frame.set("currentlyActive", t_48, true);
if(frame.topLevel) {
context.setVariable("currentlyActive", t_48);
}
if(frame.topLevel) {
context.addExport("currentlyActive", t_48);
}
;
}
t_40 += "<li class=\"";
t_40 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__li", env.opts.autoescape);
t_40 += "\"><a href=\"";
t_40 += runtime.suppressValue((lineno = 132, colno = 67, runtime.callWrap(t_4, "categoryUrl", context, [runtime.contextOrFrameLookup(context, frame, "itemSlug")])), env.opts.autoescape);
t_40 += "\" class=\"";
t_40 += runtime.suppressValue("js-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a", env.opts.autoescape);
t_40 += " ";
t_40 += runtime.suppressValue("c-" + runtime.contextOrFrameLookup(context, frame, "class") + "__a", env.opts.autoescape);
t_40 += " ";
t_40 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "currentlyActive"), env.opts.autoescape);
t_40 += "\">";
t_40 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"displayName"), env.opts.autoescape);
t_40 += "</a></li>\n        ";
;
}
;
}
}
frame = frame.pop();
t_40 += "</ul>\n";
;
frame = frame.pop();
return new runtime.SafeString(t_40);
});
context.addExport("loopThroughChildSlugs");
context.setVariable("loopThroughChildSlugs", macro_t_39);
var macro_t_49 = runtime.makeMacro(
["childSlugs", "categorySlug"], 
["class"], 
function (l_childSlugs, l_categorySlug, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("childSlugs", l_childSlugs);
frame.set("categorySlug", l_categorySlug);
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
var t_50 = "";frame = frame.push();
var t_53 = l_childSlugs;
if(t_53) {var t_52 = t_53.length;
for(var t_51=0; t_51 < t_53.length; t_51++) {
var t_54 = t_53[t_51];
frame.set("slug", t_54);
frame.set("loop.index", t_51 + 1);
frame.set("loop.index0", t_51);
frame.set("loop.revindex", t_52 - t_51);
frame.set("loop.revindex0", t_52 - t_51 - 1);
frame.set("loop.first", t_51 === 0);
frame.set("loop.last", t_51 === t_52 - 1);
frame.set("loop.length", t_52);
var t_55;
t_55 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_54);
frame.set("navItem", t_55, true);
if(frame.topLevel) {
context.setVariable("navItem", t_55);
}
if(frame.topLevel) {
context.addExport("navItem", t_55);
}
var t_56;
t_56 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"slug");
frame.set("itemSlug", t_56, true);
if(frame.topLevel) {
context.setVariable("itemSlug", t_56);
}
if(frame.topLevel) {
context.addExport("itemSlug", t_56);
}
t_50 += "<p class=\"c-off-navigation-accordion__p\">\n            <a class=\"c-off-navigation-accordion__a\" data-qa-navitem=\"\" href=\"";
t_50 += runtime.suppressValue((lineno = 155, colno = 90, runtime.callWrap(t_4, "categoryUrl", context, [runtime.contextOrFrameLookup(context, frame, "itemSlug")])), env.opts.autoescape);
t_50 += "\">";
t_50 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"displayName"), env.opts.autoescape);
t_50 += "</a>\n        </p>";
;
}
}
frame = frame.pop();
;
frame = frame.pop();
return new runtime.SafeString(t_50);
});
context.addExport("buildOffscreenNav");
context.setVariable("buildOffscreenNav", macro_t_49);
var macro_t_57 = runtime.makeMacro(
["categorySlug", "core"], 
[], 
function (l_categorySlug, l_core, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("categorySlug", l_categorySlug);
frame.set("core", l_core);
var t_58 = "";if(runtime.memberLookup((runtime.memberLookup((l_core),"flatNavigation")),l_categorySlug)) {
var t_59;
t_59 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_core),"flatNavigation")),l_categorySlug)),"parentSlug");
frame.set("currentNavigationItemParentSlug", t_59, true);
if(frame.topLevel) {
context.setVariable("currentNavigationItemParentSlug", t_59);
}
if(frame.topLevel) {
context.addExport("currentNavigationItemParentSlug", t_59);
}
var t_60;
t_60 = runtime.memberLookup((runtime.memberLookup((l_core),"flatNavigation")),runtime.contextOrFrameLookup(context, frame, "currentNavigationItemParentSlug"));
frame.set("currentNavigationItemParentObject", t_60, true);
if(frame.topLevel) {
context.setVariable("currentNavigationItemParentObject", t_60);
}
if(frame.topLevel) {
context.addExport("currentNavigationItemParentObject", t_60);
}
if(runtime.contextOrFrameLookup(context, frame, "currentNavigationItemParentObject")) {
t_58 += "<a href=\"";
t_58 += runtime.suppressValue((lineno = 176, colno = 29, runtime.callWrap(t_4, "categoryUrl", context, [runtime.contextOrFrameLookup(context, frame, "currentNavigationItemParentSlug")])), env.opts.autoescape);
t_58 += "\" class=\"js-category-navigation__a c-filter-navigation__a--parent-category\">";
t_58 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentNavigationItemParentObject")),"displayName"), env.opts.autoescape);
t_58 += "</a>";
;
}
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_58);
});
context.addExport("getParent");
context.setVariable("getParent", macro_t_57);
var macro_t_61 = runtime.makeMacro(
["categorySlug", "core"], 
["class"], 
function (l_categorySlug, l_core, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("categorySlug", l_categorySlug);
frame.set("core", l_core);
frame.set("class", kwargs.hasOwnProperty("class") ? kwargs["class"] : "");
var t_62 = "";var t_63;
t_63 = runtime.memberLookup((runtime.memberLookup((l_core),"flatNavigation")),l_categorySlug);
frame.set("currentNavigationItem", t_63, true);
if(frame.topLevel) {
context.setVariable("currentNavigationItem", t_63);
}
if(frame.topLevel) {
context.addExport("currentNavigationItem", t_63);
}
var t_64;
t_64 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentNavigationItem")),"type");
frame.set("currentCategoryPageType", t_64, true);
if(frame.topLevel) {
context.setVariable("currentCategoryPageType", t_64);
}
if(frame.topLevel) {
context.addExport("currentCategoryPageType", t_64);
}
var t_65;
t_65 = runtime.memberLookup((runtime.memberLookup((l_core),"flatNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentNavigationItem")),"parentSlug"));
frame.set("currentNavigationItemParent", t_65, true);
if(frame.topLevel) {
context.setVariable("currentNavigationItemParent", t_65);
}
if(frame.topLevel) {
context.addExport("currentNavigationItemParent", t_65);
}
if(runtime.contextOrFrameLookup(context, frame, "currentCategoryPageType") != "Gateway" && runtime.contextOrFrameLookup(context, frame, "currentNavigationItemParent") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentNavigationItemParent")),"childSlugs") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentNavigationItemParent")),"childSlugs")) > 0) {
t_62 += runtime.suppressValue((lineno = 200, colno = 30, runtime.callWrap(macro_t_39, "loopThroughChildSlugs", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentNavigationItemParent")),"childSlugs"),l_categorySlug,runtime.contextOrFrameLookup(context, frame, "class")])), env.opts.autoescape);
;
}
else {
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_62);
});
context.addExport("getSiblings");
context.setVariable("getSiblings", macro_t_61);
var macro_t_66 = runtime.makeMacro(
["categorySlug", "core"], 
[], 
function (l_categorySlug, l_core, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("categorySlug", l_categorySlug);
frame.set("core", l_core);
var t_67 = "";t_67 += "\n    ";
t_67 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_core),"flatNavigation")),l_categorySlug)),"displayName"), env.opts.autoescape);
t_67 += "\n";
;
frame = frame.pop();
return new runtime.SafeString(t_67);
});
context.addExport("getCurrentCategory");
context.setVariable("getCurrentCategory", macro_t_66);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/category-facet-macro.j2"] , dependencies)